import { toast } from "sonner";
import { Clock, CheckCircle2, XCircle } from "lucide-react";
import { PageHeader } from "@/components/AppShell";
import { useMe } from "@/context/MeContext";
import { fileUrl } from "@/lib/api";
import { EmployerForm } from "@/pages/employer/EmployerOnboarding";

const STATUS = {
  pending: { icon: Clock, cls: "border-amber-300 bg-amber-50 text-amber-900", title: "Awaiting admin verification", body: "We're reviewing your company details. You'll get an email once you're approved." },
  approved: { icon: CheckCircle2, cls: "border-emerald-300 bg-emerald-50 text-emerald-900", title: "Your company is approved", body: "You can update your company details at any time in Company profile." },
  rejected: { icon: XCircle, cls: "border-rose-300 bg-rose-50 text-rose-900", title: "Not approved yet", body: "Update your company details in Company profile and we'll review again." },
};

export default function EmployerHome() {
  const { me } = useMe();
  const emp = me.employer;
  const s = STATUS[emp.approval_status] || STATUS.pending;
  const Icon = s.icon;
  return (
    <div>
      <PageHeader eyebrow="Employer" title={emp.company_name} />
      <div className={`rise flex gap-4 rounded-2xl border p-5 sm:p-6 ${s.cls}`} data-testid="employer-approval-banner">
        <Icon className="mt-0.5 h-6 w-6 shrink-0" />
        <div>
          <p className="font-display text-lg font-bold" data-testid="employer-approval-status">{s.title}</p>
          <p className="mt-1 text-sm">{s.body}</p>
          {emp.approval_status === "rejected" && emp.decision_reason && <p className="mt-2 text-sm">Reason: {emp.decision_reason}</p>}
        </div>
      </div>
      <div className="mt-8 max-w-md">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          {emp.logo_file_id && <img src={fileUrl(`/api/files/${emp.logo_file_id}`)} alt="" className="mb-4 h-14 w-14 rounded-lg object-contain" />}
          <p className="font-display text-lg font-bold text-slate-900">{emp.company_name}</p>
          <p className="text-sm text-slate-600">{emp.industry} · {emp.size} people</p>
          <p className="text-sm text-slate-600">{emp.location}</p>
          {emp.website && <a href={emp.website} target="_blank" rel="noreferrer" className="mt-2 block text-sm text-[#222d99] underline">{emp.website}</a>}
        </div>
      </div>
    </div>
  );
}

export function EmployerProfilePage() {
  const { refresh } = useMe();
  return (
    <div>
      <PageHeader eyebrow="Employer" title="Company profile" />
      <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
        <EmployerForm onSaved={async () => { await refresh(); toast.success("Company profile saved"); }} />
      </div>
    </div>
  );
}
